import type { BookingModalOffer, RuteroMoney, TravelBooking } from './queries';

interface ResolveBookingModalDisplayAuthorityInput {
  booking: TravelBooking | null;
  currentOffer: BookingModalOffer | null;
  commercialMoney?: RuteroMoney;
  vertical: string;
  verticalLabel: string;
}

export interface BookingModalDisplayAuthority {
  isPostHold: boolean;
  provider?: string;
  capabilityProvider?: string;
  vertical: string;
  titleName: string;
  commercialMoney?: RuteroMoney;
}

const trimmed = (value: unknown): string | undefined =>
  typeof value === 'string' && value.trim() ? value.trim() : undefined;

export function resolveBookingModalDisplayAuthority({
  booking,
  currentOffer,
  commercialMoney,
  vertical,
  verticalLabel,
}: ResolveBookingModalDisplayAuthorityInput): BookingModalDisplayAuthority {
  if (booking) {
    const titleName =
      trimmed(booking.fareSnapshot?.name) ??
      trimmed(booking.fareSnapshot?.title) ??
      trimmed(verticalLabel) ??
      booking.vertical;
    const commercialMoney =
      booking.finalAmountMinor != null && booking.currency
        ? { amountMinor: booking.finalAmountMinor, currency: booking.currency }
        : undefined;

    return {
      isPostHold: true,
      provider: booking.provider,
      capabilityProvider: booking.provider,
      vertical: booking.vertical,
      titleName,
      commercialMoney,
    };
  }

  return {
    isPostHold: false,
    provider: currentOffer?.provider,
    capabilityProvider: currentOffer?.provider,
    vertical,
    titleName: currentOffer?.title ?? currentOffer?.name ?? '',
    commercialMoney,
  };
}
